import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.css';
import { GoogleOAuthProvider } from '@react-oauth/google'; // GoogleOAuthProviderのインポート

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider clientId="<Your-Google-Client-ID>"> {/* GoogleOAuthProviderでラップ */}
        <App />
    </GoogleOAuthProvider>,
  // </React.StrictMode>
);

reportWebVitals();
